import { api } from '../../api'
import { AxiosResponse } from 'axios'
import { store } from '../../../redux/store/store'
import { createEventItemSuccess } from '../../../redux/store/EditEvent/actions'
import { Tickets } from '../../../redux/store/EditEvent/types'
import { setModalState } from '../../../redux/store/Modal/Actions/actionsModal'

export type CreateEventItemRequest = {
  eventId: string
  title: string
  description: string
  dates: string[]
  maxCustomerTickets: number
  salesFrom?: string
  finalSales?: string
  ticketInfo?: {
    value: string
    isRequired: boolean
  }[]
}

export type CreateEventItemResponse = {
  id: string
  title: string
  description: string
  dates: string[]
  maxCustomerTickets: string
  salesFrom?: string
  ticketInfo?: {
    value: string
    isRequired: boolean
  }[]
  tickets: Tickets[]
}

export const createEventItemService = async (
  request: CreateEventItemRequest
) => {
  const { dispatch } = store
  let error = false
  try {
    await api
      .post(`/api/backoffice/events/${request.eventId}/eventItems`, {
        eventId: request.eventId,
        title: request.title,
        description: request.description,
        dates: request.dates,
        maxCustomerTickets: request.maxCustomerTickets,
        salesFrom: request.salesFrom,
        finalSales: request.finalSales,
        ticketInfo: request.ticketInfo
      })
      .then(({ data }: AxiosResponse<CreateEventItemResponse>) => {
        dispatch(createEventItemSuccess(data))
        dispatch(
          setModalState({
            open: true,
            variant: 'success',
            buttonText: 'Fechar',
            message: 'Sessão criada com sucesso'
          })
        )
      })
  } catch (err) {
    error = true
    dispatch(
      setModalState({
        open: true,
        variant: 'error',
        buttonText: 'Fechar',
        message: 'Data de início das vendas expirada.'
      })
    )
  }
  return error
}
